module.exports = __webpack_public_path__ + "img/water_park.8abcdeb6.svg";